import React, { useEffect, useState } from 'react'

import { MinimalAutoComplete, MinimalInput, MinimalToggleButton } from 'components/Assets/components'
import { PopupModal } from 'components/common/others'
import { FloatingButton, MinimalButtonGroup } from 'components/common/buttons'

import { components } from 'react-select'

import { snakifyKeys } from 'helpers/formatters'
import onBoardingWorkorder from 'Services/WorkOrder/on-boarding-wo'

import { conductorSizeOptions, conductorTypesOptions, connectionSteps, connectionType, eletricalPanelOptions, fedByTypeOptionsName, formatDecimal, materialNonFlexType, validate } from './utils'
import { filter, get, isEmpty, set } from 'lodash'
import { Toast } from 'Snackbar/useToast'

import RemoveIcon from '@material-ui/icons/Remove'
import { useTheme } from '@material-ui/core/styles'
import enums from 'Constants/enums'
import DialogPrompt from 'components/DialogPrompt'
import Stepper from '../maintenance-forms/multi-step-forms/common/stepper'
import useFetchData from 'hooks/fetch-data'

const CreateFedBy = ({ open, onClose, classCodeOptions, woId, afterSubmit, asset, subComponentAsset, isInstalling, assetConnectionType, loadSideOptions, issueAsset = false }) => {
  const [isCreating, setIsCreating] = useState(false)
  const [assetName, setAssetName] = useState('')
  const [assetClassCode, setClassCode] = useState(null)
  const [error, setError] = useState({})
  const theme = useTheme()
  const [subComponentList, setSubComponentList] = useState([])
  const [changeLineSide, setChangeLineSide] = useState([false, null, false])

  // fedby
  const [conductorJson, setConductorJson] = useState([])
  const [diaMeter, setDiaMeter] = useState(0)
  const [length, setLength] = useState(0)
  const [sets, setSets] = useState(0)
  const [connectType, setConnectType] = useState()
  const [material, setMaterial] = useState()
  const [activeStep, setActiveStep] = useState(connectionSteps[0])
  const [subComponentAssetOptions, setSubComponentAssetOptions] = useState([])
  const [subLevelAsset, setSubLevelAsset] = useState(null)
  const [loadSideOcpMain, setLoadSideOcpMain] = useState(null)
  const [electricalPanel, setElectricalPanel] = useState(enums.NODE_TYPE.MCB)
  const [showElectricalPanel, setShowElectricalPanel] = useState(false)
  const [connectionTypeName, setConnectionTypeName] = useState()

  const { data: allDropDownData } = useFetchData({
    fetch: onBoardingWorkorder.getAllDropdownOptionsList,
    payload: { dropdown_option_type: [enums.DROPDOWN_OPTIONS.CONDUCTOR_SIZE] },
    formatter: d => get(d, 'data.list', []),
    defaultValue: [],
    externalLoader: true,
  })

  // console.log(loadSideOptions)
  const CustomOptions = ({ children, ...props }) => {
    return (
      <components.Option {...props}>
        <div className='d-flex align-items-center justify-content-between'>
          <div className='text-bold'>{props.data.className} </div>
          <div className='text-bold text-accent'>{props.data.label}</div>
        </div>
      </components.Option>
    )
  }
  // console.log(asset)
  // panel logic
  useEffect(() => {
    if (!isEmpty(assetClassCode)) {
      setShowElectricalPanel(get(assetClassCode, 'classType', '')?.includes('ELECTRICAL PANELS') ? true : false)
      setElectricalPanel(!get(assetClassCode, 'classType', '')?.includes('ELECTRICAL PANELS') ? enums.NODE_TYPE.MCB : electricalPanel)
    } else {
      setShowElectricalPanel(false)
    }
  }, [assetClassCode])

  //
  const validateForm = async () => {
    const isValid = await validate({ assetName, assetClassCode: get(assetClassCode, 'label', ''), subComponentList }, true)
    setError(isValid)
    const subComponentErrors = []
    const subCompList = [...subComponentList]
    if (!isEmpty(subComponentList)) {
      subCompList.forEach(d => {
        const err = {}
        if (isEmpty(d.name)) err['name'] = { error: true, msg: 'Asset Name is required !' }
        if (isEmpty(d.classData)) err['classData'] = { error: true, msg: 'Asset Class Code is required !' }
        if (!isEmpty(err)) {
          d.error = err
          subComponentErrors.push(true)
        }
      })
      setSubComponentList(subCompList)
    }
    if (isValid === true && isEmpty(subComponentErrors)) setActiveStep(connectionSteps[1])
  }
  //
  const submitData = async () => {
    const payload = snakifyKeys({
      woId,
      assetName,
      inspectiontemplateAssetClassId: get(assetClassCode, 'id', ''),
      formioBuildingName: isInstalling ? get(asset, 'building', '') : get(asset, 'building.label', ''),
      formioFloorName: isInstalling ? get(asset, 'floor', '') : get(asset, 'floor.label', ''),
      formioRoomName: isInstalling ? get(asset, 'room', '') : get(asset, 'room.label', ''),
      formioSectionName: get(asset, 'section', ''),
      panelClassTypeId: electricalPanel,
      subcomponentsList: !isEmpty(subComponentList) ? subComponentList.map(val => ({ assetName: val.name, inspectiontemplateAssetClassId: val.classData.id, lineLoadSideId: get(val, 'lineLoadSideId', null) })) : null,
    })
    setIsCreating(true)
    try {
      const res = await onBoardingWorkorder.fedBy.create(payload)
      if (res.success > 0) {
        Toast.success(`New Asset Created Successfully !`)
        const anchorObj = {
          subComponentAsset: subLevelAsset,
          loadSideOcpMain,
          assetConnectionType,
          connectionTypeName,
          fedJson: {
            type: connectionType.find(d => d.value === connectType)?.label,
            material: connectType === 3 || connectType === 4 ? '' : materialNonFlexType.find(d => d.value === material)?.label,
            diameter: diaMeter || 0,
            length: length || 0,
            sets: sets || 0,
            conductors: (conductorJson || []).map(d => ({
              amount: d.amount || 0,
              material: d.material || '',
              size: get(d, 'size.value', '') ?? '',
            })),
          },
        }
        const conductorLabels = anchorObj.fedJson?.conductors
          ?.map(conductor => {
            const materialLabel = conductor.material === 'Copper' ? 'Cu' : 'Al'
            return `${conductor.amount}x ${materialLabel} ${conductor.size}`
          })
          .filter(Boolean)
          .join(', ')
        const details = [anchorObj.fedJson?.sets ? `${anchorObj.fedJson.sets} Parallel Sets` : null, anchorObj.fedJson?.diameter ? `${anchorObj.fedJson.diameter}"` : null, anchorObj.fedJson?.material ? anchorObj.fedJson.material : null, anchorObj.fedJson?.length ? `${anchorObj.fedJson.length}'` : null, conductorLabels ? conductorLabels : null]
          .filter(Boolean)
          .join(' ')

        anchorObj.fedJson['label'] = details
        afterSubmit(get(res, 'data.woonboardingassetsId', ''), anchorObj)
      } else Toast.error(res.message)
    } catch (error) {
      Toast.error(`Error create Asset. Please try again !`)
    }
    setIsCreating(false)
  }

  // sub Component handling
  const handleAddSubComponent = () => {
    const subComponent = { name: '', classData: null, error: { name: null, classData: null }, id: subComponentList.length + 1, lineLoadSideId: null }
    setSubComponentList([...subComponentList, subComponent])
  }
  const handleComponentRowChange = (name, value, id) => {
    const list = [...subComponentList]
    const current = list.find(d => d.id === id)
    current[name] = value
    if (name === 'classData') {
      if (get(value, 'is_line_load_side_allowed', false) === true) {
        current['lineLoadSideId'] = enums.SUB_COMPONENT_TYPE.LOAD_SIDE
      }
    }
    setSubComponentList(list)
  }
  const handleErrorSubComponent = (name, id) => {
    const list = [...subComponentList]
    const current = list.find(d => d.id === id)
    current['error'][name] = null
    setSubComponentList(list)
  }
  const handleRemoveComponentRow = id => {
    let list = [...subComponentList]
    list = list.filter(component => component.id !== id).map((d, i) => ({ ...d, id: i }))
    setSubComponentList(list)
  }

  const handleCheckLine = (id, lineLoadSideId) => {
    const checkLineSide = subComponentList.some(item => item.lineLoadSideId === enums.SUB_COMPONENT_TYPE.LINE_SIDE)
    if (checkLineSide) {
      setChangeLineSide([true, id, lineLoadSideId === enums.SUB_COMPONENT_TYPE.LINE_SIDE ? true : false])
    } else {
      const updatedList = subComponentList.map(item =>
        get(item, 'classData.is_line_load_side_allowed', false) === true ? (item.id === id ? { ...item, lineLoadSideId: item.lineLoadSideId !== enums.SUB_COMPONENT_TYPE.LINE_SIDE ? enums.SUB_COMPONENT_TYPE.LINE_SIDE : enums.SUB_COMPONENT_TYPE.LOAD_SIDE } : { ...item, lineLoadSideId: enums.SUB_COMPONENT_TYPE.LOAD_SIDE }) : item
      )
      setSubComponentList(updatedList)
    }
  }

  const handleChangeLineSide = id => {
    const updatedList = subComponentList.map(item =>
      get(item, 'classData.is_line_load_side_allowed', false) === true ? (item.id === id ? { ...item, lineLoadSideId: item.lineLoadSideId !== enums.SUB_COMPONENT_TYPE.LINE_SIDE ? enums.SUB_COMPONENT_TYPE.LINE_SIDE : enums.SUB_COMPONENT_TYPE.LOAD_SIDE } : { ...item, lineLoadSideId: enums.SUB_COMPONENT_TYPE.LOAD_SIDE }) : item
    )
    setSubComponentList(updatedList)
    setChangeLineSide([false, null, false])
  }

  const handleInputConductor = (id, key, value) => {
    const updatedConductor = [...conductorJson]
    const currentConductor = updatedConductor.find(d => d.id === id)
    if (key === 'increment') {
      currentConductor['amount'] = Number(currentConductor['amount']) + 1
    } else if (key === 'decrement') {
      currentConductor['amount'] = Math.max(Number(currentConductor['amount']) - 1, 1)
    } else {
      currentConductor[key] = value
    }
    setConductorJson(updatedConductor)
  }

  const handleAddConductorType = () => {
    setConductorJson(prev => [...prev, { amount: 1, material: 'Copper', size: '', id: prev.length }])
  }
  const handleRemoveConductor = id => {
    const conductorList = [...conductorJson]
    const updatedConductor = conductorList.filter(d => d.id !== id).map((ids, index) => ({ ...ids, id: index }))
    setConductorJson(updatedConductor)
  }

  const handleAction = () => {
    if (activeStep.id === connectionSteps[0].id) {
      const subCompList = [...subComponentList].map(classItem => ({
        ...classItem,
        label: classItem.name,
        value: classItem.id,
      }))
      setSubComponentAssetOptions(subCompList)
      if (!isEmpty(subLevelAsset)) setSubLevelAsset(subCompList.find(d => d.value === subLevelAsset.id))
      setLoadSideOcpMain(subCompList.find(d => d.lineLoadSideId === enums.SUB_COMPONENT_TYPE.LINE_SIDE))
      if (!isEmpty(subLevelAsset) && !isEmpty(subCompList.find(d => d.lineLoadSideId === enums.SUB_COMPONENT_TYPE.LINE_SIDE))) {
        if (subCompList.find(d => d.lineLoadSideId === enums.SUB_COMPONENT_TYPE.LINE_SIDE).id === subLevelAsset.id || isEmpty(subCompList.find(d => d.lineLoadSideId === enums.SUB_COMPONENT_TYPE.LINE_SIDE))) setSubLevelAsset(null)
      }
      validateForm()
    } else if (activeStep.id === connectionSteps[1].id) {
      submitData()
    }
  }

  const handlePanelType = type => {
    setElectricalPanel(type)
    const checkLineSide = subComponentList.some(item => item.lineLoadSideId === enums.SUB_COMPONENT_TYPE.LINE_SIDE)
    if (type === enums.NODE_TYPE.MLO && !isEmpty(subComponentList) && checkLineSide) {
      const SubList = [...subComponentList]
      const lineSub = SubList.find(d => d.lineLoadSideId === enums.SUB_COMPONENT_TYPE.LINE_SIDE)
      lineSub['lineLoadSideId'] = enums.SUB_COMPONENT_TYPE.LOAD_SIDE
      setSubComponentList(SubList)
    }
  }
  // console.log(activeStep)
  return (
    <PopupModal
      width='750px'
      open={open}
      onClose={onClose}
      title={`Create New ${issueAsset ? 'Asset' : `${assetConnectionType === enums.SUB_COMPONENT_TYPE.LINE_SIDE ? 'Line-Side Conection' : 'Load-Side Connection'} `}`}
      loading={isCreating}
      handleSubmit={handleAction}
      cta={activeStep.id === connectionSteps[0].id ? 'Next' : 'Create'}
      loadingText='Creating...'
      tblResponsive={issueAsset ? false : true}
      isFixed
      isStep={activeStep.id === connectionSteps[1].id}
      stpeText='Previous'
      handleStep={() => setActiveStep(connectionSteps[0])}
    >
      <div style={{ padding: '14px' }}>
        <Stepper steps={connectionSteps} activeStep={activeStep} />
      </div>

      {activeStep.id === connectionSteps[0].id && (
        <>
          <div className='text-bold mb-2'>Top Component</div>
          <div className='p-2' style={{ border: '1px solid #EAEAEA', borderRadius: '4px' }}>
            <div className='d-flex justify-content-between' style={{ width: '100%' }}>
              <MinimalInput value={assetName} onChange={setAssetName} label='Asset Name' placeholder='Add Asset Name' w={50} error={error.assetName} onFocus={() => setError({ ...error, assetName: null })} />
              <MinimalAutoComplete
                placeholder='Select Class'
                value={assetClassCode}
                onChange={v => setClassCode(v)}
                options={filter(classCodeOptions, { is_allowed_toplevel: true })}
                label='Asset Class'
                isClearable
                w={50}
                error={error.assetClassCode}
                onFocus={() => setError({ ...error, assetClassCode: null })}
                components={{ Option: CustomOptions }}
              />
            </div>
          </div>
          {showElectricalPanel && <MinimalButtonGroup label='Electrical PanelType' value={electricalPanel} onChange={value => handlePanelType(value)} options={eletricalPanelOptions} w={100} baseStyles={{ marginRight: 0 }} />}

          {!issueAsset && (
            <>
              <div className='text-bold mt-3 mb-2'>OCP(S)</div>
              <div className='' style={{ border: '1px solid #EAEAEA', borderRadius: '4px' }}>
                <div className='d-flex align-items-center p-2' style={{ borderBottom: '1px solid #EAEAEA' }}>
                  <div className='text-bold' style={{ width: '45%' }}>
                    Asset Name
                  </div>
                  <div className='text-bold pl-3' style={{ width: '45%' }}>
                    Asset Class
                  </div>
                  <div className='text-bold' style={{ width: '10%' }}>
                    Line Side
                  </div>
                  <div className='text-bold'>Action</div>
                </div>
                {get(assetClassCode, 'is_allowed_subcomponent', false) === true ? (
                  <>
                    {subComponentList.map(({ name, classData, id, error, lineLoadSideId }, index) => (
                      <div className='d-flex align-items-start pb-0 px-2 pt-2' key={index}>
                        <MinimalInput value={name} onChange={value => handleComponentRowChange('name', value, id)} placeholder='Add Asset Name' w={45} error={error.name} onFocus={() => handleErrorSubComponent('name', id)} />
                        <MinimalAutoComplete
                          placeholder='Select Class'
                          value={classData}
                          onChange={v => handleComponentRowChange('classData', v, id)}
                          options={filter(classCodeOptions, { is_allowed_to_create_subcomponent: true })}
                          isClearable
                          w={45}
                          error={error.classData}
                          onFocus={() => handleErrorSubComponent('classData', id)}
                          components={{ Option: CustomOptions }}
                        />
                        {get(classData, 'is_line_load_side_allowed', false) === true ? <MinimalToggleButton isCheck={lineLoadSideId === enums.SUB_COMPONENT_TYPE.LINE_SIDE} onChange={() => handleCheckLine(id, lineLoadSideId)} isDisabled={electricalPanel === enums.NODE_TYPE.MLO} /> : <span style={{ width: '55px' }}></span>}
                        <FloatingButton onClick={() => handleRemoveComponentRow(id)} icon={<RemoveIcon fontSize='small' />} style={{ background: theme.palette.primary.main, color: '#fff', width: '42px', height: '42px', marginLeft: '8px', borderRadius: '4px' }} />
                      </div>
                    ))}

                    <div onClick={handleAddSubComponent} className='p-2 m-2 text-bold' style={{ borderRadius: '4px', cursor: 'pointer', border: '1px dashed #a1a1a1', background: 'none', textAlign: 'center' }}>
                      Add New OCP
                    </div>
                  </>
                ) : (
                  <div className='p-2 m-2 text-bold' style={{ borderRadius: '4px', background: '#00000014', textAlign: 'center' }}>
                    Can't Add OCP(S) in this Asset Class
                  </div>
                )}
              </div>
            </>
          )}
        </>
      )}

      {activeStep.id === connectionSteps[1].id && (
        <>
          <div className='text-bold'>FED-BY</div>
          <div className='d-flex justify-content-between align-items-center'>
            <div>Fed-by Asset</div>
            {assetConnectionType === enums.SUB_COMPONENT_TYPE.LINE_SIDE ? <MinimalInput value={assetName} placeholder='N/A' w={45} disabled /> : <MinimalInput value={get(asset, 'assetName', '')} placeholder='N/A' w={45} disabled />}
          </div>
          <div className='d-flex justify-content-between align-items-center'>
            <div>Load-Side OCP</div>
            {assetConnectionType === enums.SUB_COMPONENT_TYPE.LINE_SIDE ? (
              <MinimalAutoComplete options={filter(subComponentAssetOptions, item => item.lineLoadSideId === enums.SUB_COMPONENT_TYPE.LOAD_SIDE)} value={subLevelAsset} onChange={setSubLevelAsset} placeholder='Select OCP' w={45} isClearable />
            ) : (
              <MinimalAutoComplete options={loadSideOptions} value={subLevelAsset} onChange={value => setSubLevelAsset(value)} placeholder='Select OCP' w={45} isClearable />
            )}
          </div>
          <div className='text-bold mt-2'>FEEDING</div>
          <div className='d-flex justify-content-between align-items-center'>
            <div>Feeding Asset</div>
            {assetConnectionType === enums.SUB_COMPONENT_TYPE.LINE_SIDE ? <MinimalInput value={get(asset, 'assetName', '')} placeholder='N/A' w={45} disabled /> : <MinimalInput value={assetName} placeholder='N/A' w={45} disabled />}
          </div>
          <div className='d-flex justify-content-between align-items-center'>
            <div>Line-Side OCP Main</div>
            {assetConnectionType === enums.SUB_COMPONENT_TYPE.LINE_SIDE ? <MinimalInput w={45} value={get(subComponentAsset, 'name', '')} placeholder='N/A' disabled /> : <MinimalInput w={45} value={get(loadSideOcpMain, 'label', '')} placeholder='N/A' disabled />}
          </div>
          <div className='text-bold mt-2'>CONNECTION DETAILS</div>
          <div className='d-flex justify-content-between align-items-center mt-2'>
            <div>Connection Type</div>
            <MinimalButtonGroup value={connectionTypeName} onChange={setConnectionTypeName} options={fedByTypeOptionsName} w={45} />
          </div>
          <div className='d-flex justify-content-between align-items-center'>
            <div>Type</div>
            <MinimalButtonGroup value={connectType} onChange={setConnectType} options={connectionType} w={76} />
          </div>
          {(connectType === 1 || connectType === 2) && (
            <div className='d-flex justify-content-between align-items-center'>
              <div>Material</div>
              {connectType === 1 && <MinimalButtonGroup value={material} onChange={setMaterial} options={filter(materialNonFlexType, obj => obj.value <= 4)} w={50} />}
              {connectType === 2 && <MinimalButtonGroup value={material} onChange={setMaterial} options={filter(materialNonFlexType, obj => obj.value >= 5)} w={50} />}
            </div>
          )}
          <div className='d-flex justify-content-between align-items-center' style={{ height: '50px' }}>
            <div>Diameter (inches)</div>
            <div className='d-flex align-items-center justify-content-between mx-2' style={{ fontSize: 15, width: '130px' }}>
              <span className='d-flex align-items-center justify-content-center text-bold' style={{ width: 25, height: 25, cursor: 'pointer', border: '1px solid', borderRadius: '50%' }} onClick={() => setDiaMeter(Math.max(diaMeter - 0.25, 0))}>
                −
              </span>
              <span className='text-bold'>{formatDecimal(diaMeter)}</span>
              <span className='d-flex align-items-center justify-content-center text-bold' style={{ width: 25, height: 25, cursor: 'pointer', border: '1px solid', borderRadius: '50%' }} onClick={() => setDiaMeter(diaMeter + 0.25)}>
                +
              </span>
            </div>
          </div>
          <div className='d-flex justify-content-between align-items-center' style={{ height: '50px' }}>
            <div>Length (feet)</div>
            <div className='d-flex align-items-center justify-content-between mx-2' style={{ fontSize: 15, width: 130 }}>
              <span className='d-flex align-items-center justify-content-center text-bold' style={{ width: 25, height: 25, cursor: 'pointer', border: '1px solid', borderRadius: '50%' }} onClick={() => setLength(Math.max(length - 5, 0))}>
                −
              </span>
              <input
                className='no-spinner'
                type='number'
                min={0}
                value={length}
                onChange={e => setLength(Math.max(Number(e.target.value), 0))}
                style={{
                  width: 50,
                  height: 25,
                  textAlign: 'center',
                  border: 'none',
                  outline: 'none',
                  fontWeight: 'bold',
                  background: 'transparent',
                  fontSize: 15,
                  margin: '0 4px',
                }}
              />
              <span className='d-flex align-items-center justify-content-center text-bold' style={{ width: 25, height: 25, cursor: 'pointer', border: '1px solid', borderRadius: '50%' }} onClick={() => setLength(length + 5)}>
                +
              </span>
            </div>
          </div>
          <div className='d-flex justify-content-between align-items-center' style={{ height: '50px' }}>
            <div>Parallel Sets</div>
            <div className='d-flex align-items-center justify-content-between mx-2' style={{ fontSize: 15, width: '130px' }}>
              <span className='d-flex align-items-center justify-content-center text-bold' style={{ width: 25, height: 25, cursor: 'pointer', border: '1px solid', borderRadius: '50%' }} onClick={() => setSets(Math.max(sets - 1, 0))}>
                −
              </span>
              <span className='text-bold'>{sets}</span>
              <span className='d-flex align-items-center justify-content-center text-bold' style={{ width: 25, height: 25, cursor: 'pointer', border: '1px solid', borderRadius: '50%' }} onClick={() => setSets(sets + 1)}>
                +
              </span>
            </div>
          </div>
          <div className='d-flex justify-content-between' style={{ position: 'relative' }}>
            <div className='text-bold mt-2'>CONDUCTORS</div>
            <div className='text-bold' style={{ position: 'absolute', right: '11px', top: '12px' }}>
              Conductor Size
            </div>
          </div>
          {conductorJson?.map(d => {
            return (
              <div className='d-flex justify-content-between align-items-center mt-2' key={d.id}>
                <div className='d-flex justify-content-between align-items-center' style={{ height: '50px' }}>
                  <div className='d-flex align-items-center justify-content-between' style={{ fontSize: 15, width: '115px' }}>
                    <span className='d-flex align-items-center justify-content-center text-bold' style={{ width: 25, height: 25, cursor: 'pointer', border: '1px solid', borderRadius: '50%' }} onClick={() => handleInputConductor(d.id, 'decrement', '')}>
                      −
                    </span>
                    <span className='text-bold'>{get(d, 'amount', 0)}</span>
                    <span className='d-flex align-items-center justify-content-center text-bold' style={{ width: 25, height: 25, cursor: 'pointer', border: '1px solid', borderRadius: '50%' }} onClick={() => handleInputConductor(d.id, 'increment', '')}>
                      +
                    </span>
                  </div>
                </div>
                <MinimalButtonGroup value={get(d, 'material', 'Copper')} onChange={value => handleInputConductor(d.id, 'material', value)} options={conductorTypesOptions} w={25} baseStyles={{ marginTop: '10px' }} />
                <div className='d-flex'>
                  <MinimalAutoComplete options={get(allDropDownData, `${enums.DROPDOWN_OPTIONS.CONDUCTOR_SIZE}`, conductorSizeOptions)} value={get(d, 'size', '')} onChange={value => handleInputConductor(d.id, 'size', value)} isClearable baseStyles={{ marginTop: '10px', width: '180px' }} />
                  <FloatingButton onClick={() => handleRemoveConductor(d.id)} icon={<RemoveIcon fontSize='small' />} style={{ background: theme.palette.primary.main, color: '#fff', width: '42px', height: '42px', borderRadius: '4px', marginTop: '15px' }} />
                </div>
              </div>
            )
          })}
          {conductorJson.length < 4 && (
            <div onClick={handleAddConductorType} className='p-2 m-2 text-bold' style={{ borderRadius: '4px', cursor: 'pointer', border: '1px dashed #a1a1a1', background: 'none', textAlign: 'center' }}>
              Add Conductor Type
            </div>
          )}
        </>
      )}
      {/* Line/load side */}
      <DialogPrompt
        title={`${changeLineSide[2] ? 'Remove' : 'Assign'} Line-Side Component`}
        text={changeLineSide[2] ? 'Are you sure you want to Remove this sub-component (OCP) as a Line-Side component?' : 'Are you sure you want to Assign this sub-component (OCP) as a Line-Side component? The current Line-Side component will be converted to a Load-Side component. Please confirm!'}
        open={changeLineSide[0]}
        ctaText={`${changeLineSide[2] ? 'Remove' : 'Confirm'}`}
        action={() => handleChangeLineSide(changeLineSide[1])}
        handleClose={() => setChangeLineSide([false, null, false])}
      />
    </PopupModal>
  )
}

export default CreateFedBy
